<template>
  <div>
    <h5 class="headline">{{ $t('contract.goodwill.headline') }}</h5>
    <div v-if="!isDistributor">
      <p style="margin-bottom: 12px;">{{ $t('contract.goodwill.not_relevant_text') }}</p>
    </div>
    <div v-else>
      <p>{{ $t('contract.goodwill.paragraph_one') }}</p>
      <p>{{ $t('contract.goodwill.paragraph_two', {percent: goodwillPercent}) }}</p>
      <p>{{ $t('contract.goodwill.paragraph_three') }}</p>
      <p>{{ $t('contract.goodwill.paragraph_four', {addon: pargraphFourAddon}) }}</p>
      <p>{{ $t('contract.goodwill.paragraph_five') }}</p>
    </div>
    <hr />
  </div>
</template>

<script>
export default {
  computed: {
    isDistributor() {
      return this.$store.getters.isDistributorType;
    },
    isFixedPeriod() {
      return (
        this.$store.state.contract.durationAndResignation.selectedDuration ===
        this.$t("form.duration_and_resignation.duration.options.limited")
      );
    },
    pargraphFourAddon() {
      return this.isFixedPeriod
        ? ""
        : this.$t("contract.goodwill.paragraph_four_addon");
    },
    goodwillPercent() {
      return this.$store.state.contract.goodwillPercent !== ""
        ? this.$store.state.contract.goodwillPercent
        : this.$t("contract.goodwill.placeholder.percent");
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/eneforhandler/components/contract/GoodwillOutput.vue